import { deprecatedColors } from "@/styles/deprecated-colors";

import { Faq as FaqComponent } from "../../Faq";
import type { BuilderTextProps } from "../Typography/Text/Text";
import { BuilderText } from "../Typography/Text/Text";

import type { FaqProps } from "./Faqs.types";

function convertVariants(
  questionTextVariant: string,
): BuilderTextProps["variant"] {
  if (questionTextVariant === "Label") {
    return "label";
  }
  return questionTextVariant.replace(
    /Text(\d+)/,
    "text-$1",
  ) as BuilderTextProps["variant"];
}

export const Faq = ({
  answer,
  question,
  textColor,
  questionTextVariant = "Text1",
  bodyVariant = "Text3",
  ...props
}: FaqProps) => {
  const heading = (
    <BuilderText
      className="text-center"
      style={{
        color: textColor ? deprecatedColors[textColor] : undefined,
      }}
      variant={convertVariants(questionTextVariant)}
    >
      {question}
    </BuilderText>
  );

  return (
    <FaqComponent question={heading} {...props}>
      <BuilderText
        dangerouslySetInnerHTML={{ __html: answer }}
        style={{
          color: textColor ? deprecatedColors[textColor] : undefined,
        }}
        variant={convertVariants(bodyVariant)}
      />
    </FaqComponent>
  );
};
